import { Text } from '@/lib'

import { KaiAlertProps } from './kai-alert.type'
import styles from './kai-alert.module.css'

export const KaiAlert = ({ title, className, children }: KaiAlertProps) => {
  return (
    <div className={`${styles.core} ${className}`}>
      <img src="/images/ai-robot.gif" alt="ai-data" />

      <div className={styles.content}>
        {title && (
          <Text variant="title-medium" className={styles.title}>
            {title}
          </Text>
        )}

        {children}
      </div>
    </div>
  )
}
